<template>
  <div v-if="loading" class="tes-loader__overlay">
    <div class="tes-loader__icon tes-loader__icon_ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EllipsisLoader',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.tes-loader__icon_ellipsis {
}

.tes-loader__icon_ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: $baseThemeColor;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.tes-loader__icon_ellipsis div:nth-child(1) {
  left: 8px;
  animation: tes-loader__icon_ellipsis1 0.6s infinite;
}

.tes-loader__icon_ellipsis div:nth-child(2) {
  left: 8px;
  animation: tes-loader__icon_ellipsis2 0.6s infinite;
}

.tes-loader__icon_ellipsis div:nth-child(3) {
  left: 32px;
  animation: tes-loader__icon_ellipsis2 0.6s infinite;
}

.tes-loader__icon_ellipsis div:nth-child(4) {
  left: 56px;
  animation: tes-loader__icon_ellipsis3 0.6s infinite;
}

@keyframes tes-loader__icon_ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes tes-loader__icon_ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes tes-loader__icon_ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
